export const MEMBER_ROLE = {
  OWNER: 'owner',
  MEMBER: 'member',
  INVITED: 'invited'
};
